import { useEffect } from "react";

const APP_NAME = "Ark Climate";

export function useDocumentTitle(title?: string) {
  useEffect(() => {
    if (title) {
      document.title = `${title} — ${APP_NAME}`;
    } else {
      document.title = APP_NAME;
    }

    // Resetting to the app name (instead of restoring the captured previous
    // title) avoids a stale-title race: under Suspense the next page's effect
    // can run before this cleanup, which would overwrite the newer title.
    return () => {
      document.title = APP_NAME;
    };
  }, [title]);
}
